import React, { useContext, useMemo } from "react";
import FlowContext from "../../../../../contexts/flowContext";
import styles from "../edgeList.module.css";

const Node = ({ id }) => {
  const [flowState, flowDispatcher] = useContext(FlowContext);

  const node = useMemo(() => {
    return flowState.nodes.filter((node) => node.id === id)[0];
  }, [id]);

  return <div className={styles.node}>{node ? node.data.name : ""}</div>;
};

export default Node;
